import { toString, Record } from "./fable_modules/fable-library-js.4.29.0/Types.js";
import { record_type, string_type } from "./fable_modules/fable-library-js.4.29.0/Reflection.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { mapIndexed, map } from "./fable_modules/fable-library-js.4.29.0/Array.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty, singleton, append, delay, toList, iterate } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { map as map_1, toArray } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { createDisposable } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { createObj } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { Caption1, Text as Text$, tokens, Portal, Spinner, SearchBox } from "@fluentui/react-components";
import { singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.29.0/Util.js";

class Kommune extends Record {
    constructor(Kommunenummer, Kommunenavn, Fylkesnummer) {
        super();
        this.Kommunenummer = Kommunenummer;
        this.Kommunenavn = Kommunenavn;
        this.Fylkesnummer = Fylkesnummer;
    }
}

function Kommune_$reflection() {
    return record_type("MunicipalitySearch.Kommune", [], Kommune, () => [["Kommunenummer", string_type], ["Kommunenavn", string_type], ["Fylkesnummer", string_type]]);
}

function fetchKommuner(query) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const encoded = encodeURIComponent(query + "*");
        return (fetch(`https://ws.geonorge.no/kommuneinfo/v1/sok?knavn=${encoded}`).then(r => r.json())).then((_arg) => {
            const arr = _arg.kommuner;
            return Promise.resolve(map((o) => {
                let norsk;
                return new Kommune(toString(o.kommunenummer), (norsk = o.kommunenavnNorsk, (norsk == null) ? toString(o.kommunenavn) : toString(norsk)), toString(o.fylkesnummer));
            }, arr));
        });
    }));
}

export function Component(componentInputProps) {
    let elems_2;
    const disabled = componentInputProps.disabled;
    const placeholder = componentInputProps.placeholder;
    const onChange = componentInputProps.onChange;
    const value = componentInputProps.value;
    const patternInput = reactApi.useState([]);
    const suggestions = patternInput[0];
    const setSuggestions = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const setOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setLoading = patternInput_2[1];
    const debounceId = reactApi.useRef(undefined);
    const anchorRef = reactApi.useRef(undefined);
    const dependencies = [value];
    reactApi.useEffect(() => {
        iterate((id) => {
            clearTimeout(id);
        }, toArray(debounceId.current));
        if (value.trim().length < 2) {
            setSuggestions([]);
            setLoading(false);
        }
        else {
            setLoading(true);
            const id_1 = (setTimeout((() => {
                const pr = fetchKommuner(value.trim());
                void (pr.then((results) => {
                    setSuggestions(results);
                    setLoading(false);
                    setOpen(true);
                }));
            }), 250)) | 0;
            debounceId.current = id_1;
        }
        createDisposable(() => {
            iterate((id_2) => {
                clearTimeout(id_2);
            }, toArray(debounceId.current));
        });
    }, dependencies);
    const anchorRect = patternInput_1[0] ? map_1((el) => el.getBoundingClientRect(), anchorRef.current) : undefined;
    return createElement("div", createObj(ofArray([["ref", anchorRef], ["style", {
        position: "relative",
        width: 100 + "%",
    }], ["onFocus", (_arg_1) => {
        if (suggestions.length > 0) {
            setOpen(true);
        }
    }], ["onBlur", (_arg_2) => {
        setTimeout((() => {
            setOpen(false);
        }), 150);
    }], (elems_2 = toList(delay(() => {
        let el_3;
        return append(singleton((el_3 = SearchBox, createElement(el_3, createObj(toList(delay(() => append(singleton(["style", {
            minWidth: 250,
            width: 100 + "%",
        }]), delay(() => append(singleton(["disabled", disabled]), delay(() => append(singleton(["value", value]), delay(() => {
            let matchValue;
            return append((matchValue = placeholder, (matchValue == null) ? (empty()) : singleton(["placeholder", matchValue])), delay(() => append(singleton(["onChange", (_arg_3, value_1_4) => {
                onChange(value_1_4.value);
            }]), delay(() => {
                let el_1;
                return patternInput_2[0] ? singleton(["contentAfter", (el_1 = Spinner, createElement(el_1, {
                    size: "tiny",
                }))]) : empty();
            }))));
        })))))))))))), delay(() => {
            let rect, rect_1, el_9, elems_1;
            return (anchorRect != null) ? (((rect = anchorRect, suggestions.length > 0)) ? ((rect_1 = anchorRect, singleton((el_9 = Portal, createElement(el_9, {
                children: singleton_1(createElement("div", createObj(ofArray([["style", {
                    position: "fixed",
                    top: (~~rect_1.bottom + 4) + "px",
                    left: ~~rect_1.left + "px",
                    width: ~~rect_1.width + "px",
                    zIndex: 100,
                    backgroundColor: tokens.colorNeutralBackground1,
                    border: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke1,
                    borderRadius: tokens.borderRadiusMedium,
                    boxShadow: "0 4px 12px var(--colorNeutralShadowAmbient), 0 8px 16px var(--colorNeutralShadowKey)",
                    maxHeight: 280,
                    overflowY: "auto",
                }], (elems_1 = ofArray(mapIndexed((i, k) => {
                    let elems, el_5, el_7;
                    return createElement("button", createObj(ofArray([["key", i], ["style", {
                        display: "block",
                        width: 100 + "%",
                        textAlign: "left",
                        padding: ((8 + "px ") + 12) + "px",
                        backgroundColor: "transparent",
                        border: (((0 + "px ") + "none") + " ") + "transparent",
                        borderBottom: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke3,
                        cursor: "pointer",
                        fontSize: 0.875 + "rem",
                        color: tokens.colorNeutralForeground1,
                    }], ["onMouseDown", (e) => {
                        e.preventDefault();
                    }], ["onClick", (_arg_4) => {
                        onChange(k.Kommunenavn);
                        setOpen(false);
                    }], (elems = [(el_5 = Text$, createElement(el_5, {
                        style: {
                            display: "block",
                        },
                        children: k.Kommunenavn,
                    })), (el_7 = Caption1, createElement(el_7, {
                        style: {
                            display: "block",
                            color: tokens.colorNeutralForeground3,
                        },
                        children: `Kommunenr. ${k.Kommunenummer} · Fylke ${k.Fylkesnummer}`,
                    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
                }, suggestions)), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))),
            }))))) : singleton(defaultOf())) : singleton(defaultOf());
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

//# sourceMappingURL=MunicipalitySearch.jsx.map
